import Feature from './Feature';
import Render from './Render';

export default {
    Feature,
    Render
};
